import { DialogRef } from '@angular/cdk/dialog';
import { Directive, inject } from '@angular/core';

@Directive({
  selector: '[appCloseModal]',
  host: {
    '(click)': 'closeModal()',
  },
})
export class CloseModalDirective {
  private _dialogRef = inject(DialogRef);

  protected closeModal() {
    this._dialogRef.close();
  }
}
